var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEkkoAppLogoHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1145.95 299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#New_Gradient_Swatch_1);}.cls-2{fill:url(#New_Gradient_Swatch_1-2);}.cls-3{fill:url(#New_Gradient_Swatch_1-3);}.cls-4{fill:url(#New_Gradient_Swatch_1-4);}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:#0091ac;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 331.44,
    y1: 264,
    x2: 331.44,
    y2: 122.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 487.11,
    y1: 260.61,
    x2: 487.11,
    y2: 40,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    x1: 629.56,
    y1: 260.61,
    x2: 629.56,
    y2: 40,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-4",
    x1: 766.5,
    y1: 264,
    x2: 766.5,
    y2: 122.49,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 80.66,
    y1: -1032,
    x2: 157,
    y2: -1032,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -801.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#235d6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 81,
    y1: -997.9,
    x2: 157,
    y2: -997.9,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -801.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63c1ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007c96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 139.81,
    y1: -822.33,
    x2: 183.5,
    y2: -904.49,
    gradientTransform: "matrix(1, 0, 0, -1, -0.16, -799.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0099b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#008097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#194f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013649"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 225.42,
    y1: -866.88,
    x2: 138.98,
    y2: -939.41,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -801.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009cc3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 52.12,
    y1: 173.17,
    x2: 31.32,
    y2: 116.01,
    gradientTransform: "matrix(0.89, 0.46, -0.46, 0.89, 70.99, -2.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00929d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ac2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.88,197.56c0,3.41-3.39,4.95-9.88,4.95H283.55c4.32,22.56,23.78,41.09,47.9,41.09a47.07,47.07,0,0,0,32.74-13.28c3.71-3.71,7.09-5.55,12.35-5.55h4c8,0,11.75,5.55,6.79,12A70.72,70.72,0,0,1,331.45,264C292.82,264,261,230.94,261,193c0-38.64,31.82-70.46,70.45-70.46s70.43,31.82,70.43,70.46ZM283.55,182.74h95.78c-4.63-22.56-23.8-39.86-47.88-39.86S288.18,160.18,283.55,182.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.7,49.88c0-6.48,3.41-9.88,9.89-9.88h.92c6.5,0,9.9,3.4,9.9,9.88V171.32h4.64l45.71-44.5a15.86,15.86,0,0,1,12.06-4.94h7.41c7.43,0,8.34,5.86,1.85,12.05l-43.24,42,62.71,72.59c5.56,6.5,3.09,12.07-5.56,12.07h-4.32c-5.26,0-9-1.55-12.36-5.57L463.7,190.78l-13.29,13v47c0,6.49-3.4,9.9-9.9,9.9h-.92c-6.48,0-9.89-3.41-9.89-9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M572.15,49.88c0-6.48,3.41-9.88,9.9-9.88H583c6.49,0,9.88,3.4,9.88,9.88V171.32h4.64l45.73-44.5a15.83,15.83,0,0,1,12-4.94h7.41c7.43,0,8.36,5.86,1.86,12.05l-43.26,42L684,248.54c5.57,6.5,3.08,12.07-5.57,12.07h-4.32c-5.26,0-9-1.55-12.35-5.57l-55.62-64.26-13.29,13v47c0,6.49-3.39,9.9-9.88,9.9h-.92c-6.49,0-9.9-3.41-9.9-9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.06,193c0-38.64,31.83-70.46,70.44-70.46S837,154.31,837,193c0,38-31.82,71.05-70.45,71.05S696.06,230.94,696.06,193Zm21.63,0c0,26.86,21.31,50.65,48.81,50.65s48.82-23.79,48.82-50.65c0-27.52-21.33-50.07-48.82-50.07S717.69,165.43,717.69,193Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gradient_bottom",
    className: "cls-5",
    d: "M84.8,230.68a37.41,37.41,0,0,0,51.3,15.2c12.35-6.65,20-18,20.9-30.4-19.95,2.85-54.15,0-76-5.7h0A33,33,0,0,0,84.8,230.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gradient_top",
    className: "cls-6",
    d: "M157,215.48h0c0-6.65-.95-14.25-3.8-19.95a37.41,37.41,0,0,0-51.3-15.2c-12.35,5.7-19,17.1-20.9,29.45C101.9,215.48,137,218.36,157,215.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M141.75,21.71C110.42,37.89,98.11,75,113.35,105.34a19.87,19.87,0,0,0,3.8,5.7c27.56,3.77,56-.07,81.69-14.34,12.34-6.67,23.73-14.28,33.22-23.79a51.69,51.69,0,0,0-6.68-25.64C210.15,16.88,172.13,5.53,141.75,21.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M117.1,111c17.1,25.65,51.3,34.2,80.75,20A61.46,61.46,0,0,0,232.05,73c-9.5,9.5-20.9,17.1-33.25,23.75A132.17,132.17,0,0,1,117.1,111Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 42.03,
    cy: 145.3,
    rx: 31.35,
    ry: 30.4,
    transform: "translate(-61.79 35.3) rotate(-27.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M865.71,224.79A38.89,38.89,0,0,1,904.4,186.1a36.55,36.55,0,0,1,28.17,13.4v-6.79c0-3.56,1.86-5.42,5.43-5.42h.51c3.56,0,5.42,1.86,5.42,5.42v64.15c0,3.56-1.86,5.43-5.42,5.43H938c-3.57,0-5.43-1.87-5.43-5.43v-6.79a36.3,36.3,0,0,1-28.17,13.75C883.19,263.82,865.71,245.66,865.71,224.79Zm66.18,0c0-15.1-13.07-27.49-27.83-27.49-15.1,0-26.47,12.39-26.47,27.49,0,14.76,11.37,27.83,26.47,27.83C918.82,252.62,931.89,239.55,931.89,224.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1044.23,224.79c0,20.87-17.48,39-38.69,39a36.3,36.3,0,0,1-28.17-13.75v40.39c0,3.56-1.87,5.43-5.43,5.43h-.51c-3.56,0-5.43-1.87-5.43-5.43V192.71c0-3.56,1.87-5.42,5.43-5.42h.51c3.56,0,5.43,1.86,5.43,5.42v6.79a36.55,36.55,0,0,1,28.17-13.4A38.89,38.89,0,0,1,1044.23,224.79Zm-11.88,0c0-15.1-11.37-27.49-26.47-27.49-14.77,0-27.83,12.39-27.83,27.49,0,14.76,13.06,27.83,27.83,27.83C1021,252.62,1032.35,239.55,1032.35,224.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1137.73,224.79c0,20.87-17.47,39-38.69,39a36.28,36.28,0,0,1-28.16-13.75v40.39c0,3.56-1.87,5.43-5.43,5.43h-.51c-3.57,0-5.43-1.87-5.43-5.43V192.71c0-3.56,1.86-5.42,5.43-5.42h.51c3.56,0,5.43,1.86,5.43,5.42v6.79A36.53,36.53,0,0,1,1099,186.1,38.88,38.88,0,0,1,1137.73,224.79Zm-11.87,0c0-15.1-11.37-27.49-26.48-27.49-14.76,0-27.83,12.39-27.83,27.49,0,14.76,13.07,27.83,27.83,27.83C1114.49,252.62,1125.86,239.55,1125.86,224.79Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEkkoAppLogoHorizontal);
export default __webpack_public_path__ + "static/media/ekko-app-logo-horizontal.0a0f40dd91a809124dc3f36f2aa6b94f.svg";
export { ForwardRef as ReactComponent };